import { defaultMultilineTextCellCDSProps } from '@sharedCR/coreDesignSystem/Table/TableCDS';

import { EMPTY_FIELD_VALUE, MersPreviewFieldColumn } from './MersPreviewDrawer.constants';

// The MERS field values in the order a person reads them: Field / Value / Note. Values and notes wrap instead of being
// cut off: a note is often why MERS would refuse, and this read-only table is there to be read in full.
export const MERS_PREVIEW_FIELDS_TABLE_CONFIG = {
  [MersPreviewFieldColumn.LABEL]: {
    label: 'Field',
    width: '30%',
  },
  [MersPreviewFieldColumn.VALUE]: {
    label: 'Value',
    width: '35%',
    content: ({ value }) => value ?? EMPTY_FIELD_VALUE,
    ...defaultMultilineTextCellCDSProps,
  },
  [MersPreviewFieldColumn.NOTE]: {
    label: 'Note',
    content: ({ note }) => note ?? '',
    ...defaultMultilineTextCellCDSProps,
  },
};
